import LordIcon from "../../../../../../../../components/ui/LordIcon";
import {Colors} from "../../../../../../../../components/theme";
import {ListInformationElement} from "./ListInformationElement";
import React from "react";

const mus_entry = (musician, index, handlePopup) => {
    if (!musician) return;

    const cn_plus = () => (
        <span className="addGroup" onClick={() => handlePopup("additionalForm", musician)} >
            {musician.first_name} {musician.last_name}
            <LordIcon url='cross' color={`${Colors.red};`} rotate='45' target='.addGroup'/>
        </span>
    )

    const fields = [
        {
            content: index,
            widthLimit: '3%'
        },
        {
            content: cn_plus,
            widthLimit: '23%'
        },
        {
            content: musician.instrument,
            widthLimit: '17%'
        },
        {
            content: 'input',
            widthLimit: '27%',
            style: {margin: '0 auto', textAlign: 'center'}
        },
        {
            content: 'input',
            widthLimit: '27%',
            style: {margin: '0 auto', textAlign: 'center'}
        },
        {
            content: 'X',
            widthLimit: '3%'
        },
    ];

    return <ListInformationElement fields={fields} />
}

export default mus_entry;
